import log from 'loglevel'
import { useInterval } from 'usehooks-ts'
import { useRef } from 'react'

export const useAsyncInterval = (
  callback: () => Promise<void>,
  delay: number,
): void => {
  const busyRequestRef = useRef(false)

  useInterval(
    async () => {
      if (busyRequestRef.current) {
        log.info('Async interval is busy, skipping callback')
        return
      }
      busyRequestRef.current = true
      try {
        await callback()
      } catch (error) {
        log.error('Error in async interval', error)
      } finally {
        busyRequestRef.current = false
      }
    },
    delay ? delay : null,
  )
}
